<div class="policy">
  <h1 class="policy__title">Quy chế hoạt động</h1>
  <div class="policy__divider"></div>
  <div class="policy__content">

    <!-- ===== I. NGUYÊN TẮC CHUNG ===== -->
    <h2>I. NGUYÊN TẮC CHUNG</h2>

    <h3>1. Mục đích</h3>
    <p>
      Website Sàn giao dịch thương mại điện tử 11N02 (sau đây gọi là 11N02, sàn 11N02) do Công ty Cổ phần Digital and
      Stock (sau đây gọi là Công ty) thực hiện hoạt động và vận hành với các chức năng chính sau:
    </p>
    <ul>
      <li>Cung cấp nền tảng mua bán sản phẩm thời trang: Cung cấp môi trường trực tuyến để Người bán đăng tải, giới
        thiệu và kinh doanh các sản phẩm thời trang như quần áo, giày dép, phụ kiện,… đến Người mua trên toàn quốc.
      </li>
      <li>Tìm kiếm và lựa chọn sản phẩm: Người mua có thể tìm kiếm, so sánh và lựa chọn sản phẩm theo danh mục,
        thương hiệu, giá cả hoặc nhu cầu cá nhân; đồng thời thực hiện đặt hàng trực tuyến trên hệ thống.</li>
      <li>Quản lý và theo dõi đơn hàng: Hỗ trợ Người mua và Người bán theo dõi trạng thái đơn hàng, thông tin giao
        nhận, lịch sử giao dịch và các hoạt động liên quan trên hệ thống.</li>
      <li>Hỗ trợ giao dịch và thanh toán: Cung cấp các phương thức thanh toán phù hợp (COD, VNPay,…) và hỗ trợ xử lý
        giao dịch giữa Người mua và Người bán.</li>
    </ul>

    <h3>2. Nguyên tắc chung</h3>
    <p>Quy chế này áp dụng đối với các thành viên đăng ký sử dụng dịch vụ trên Website Sàn giao dịch thương mại điện
      tử 11N02, bao gồm Người mua và Người bán.</p>
    <p>Sàn giao dịch thương mại điện tử 11N02 hoạt động dựa trên các nguyên tắc sau:</p>
    <ul>
      <li>Thành viên tham gia 11N02 là các tổ chức, cá nhân có đầy đủ năng lực pháp lý và năng lực hành vi dân sự theo
        quy định của pháp luật Việt Nam.</li>
      <li>Các bên tham gia giao dịch trên 11N02 tự do thỏa thuận trên cơ sở tôn trọng quyền và lợi ích hợp pháp của
        các bên, không trái với quy định của pháp luật.</li>
      <li>Thông tin về sản phẩm, giá bán, chính sách giao hàng, đổi trả và các điều kiện liên quan phải được Người bán
        cung cấp công khai, minh bạch trên hệ thống.</li>
      <li>Thành viên tham gia 11N02 có trách nhiệm cung cấp thông tin trung thực, chính xác và chịu trách nhiệm trước
        pháp luật đối với các nội dung do mình đăng tải hoặc thực hiện trên hệ thống.</li>
      <li>Tất cả các hoạt động trên 11N02 phải tuân thủ các quy định của pháp luật hiện hành của Việt Nam về thương mại
        điện tử và các quy định pháp luật có liên quan.</li>
    </ul>

    <h3>3. Địa chỉ truy cập Sàn giao dịch TMĐT 11N02</h3>
    <p>Địa chỉ truy cập Website Sàn giao dịch thương mại điện tử 11N02: <a href="https://11n02.com/"
        target="_blank">https://11n02.com/</a></p>
    <p>Địa chỉ truy cập dành cho Người bán (Nhà cung cấp): <a href="https://dashboard.11n02.com/"
        target="_blank">https://dashboard.11n02.com/</a></p>


    <!-- ===== II. QUY ĐỊNH CHUNG ===== -->
    <h2>II. QUY ĐỊNH CHUNG</h2>

    <h3>1. Định nghĩa chung</h3>
    <p><strong>a. Người mua:</strong> là thương nhân, tổ chức hoặc cá nhân đăng ký tài khoản trên Website 11N02 để tìm
      kiếm, lựa chọn và đặt mua sản phẩm từ các Nhà bán hàng trên Sàn.</p>
    <p><strong>b. Người bán (Nhà cung cấp):</strong> là thương nhân, tổ chức hoặc cá nhân đăng ký tài khoản, được Ban
      quản lý Sàn phê duyệt và thực hiện mở gian hàng, đăng tải sản phẩm để kinh doanh trên Website 11N02.</p>
    <p><strong>c. Thành viên:</strong> là thương nhân, tổ chức hoặc cá nhân đã đăng ký tài khoản trên Website 11N02 để
      sử dụng các chức năng của Sàn, bao gồm Người mua và Người bán.</p>
    <p><strong>d. Giao dịch thương mại điện tử:</strong> là hoạt động mua bán sản phẩm được thực hiện giữa Người mua và
      Người bán thông qua các chức năng của Website 11N02 như tìm kiếm sản phẩm, thêm vào giỏ hàng, đặt hàng và thanh
      toán.</p>
    <p><strong>e. Ban quản lý Sàn:</strong> là Công ty Cổ phần Digital and Stock, đơn vị sở hữu, quản lý và vận hành
      Website Sàn giao dịch thương mại điện tử 11N02.</p>

    <h3>2. Quy định chung</h3>
    <p>Khi tham gia Sàn giao dịch thương mại điện tử <strong>11N02</strong>, các Thành viên cần tuân thủ các quy định
      sau:</p>
    <ul>
      <li>Điều khoản đăng ký thành viên trên Website 11N02 có giá trị ràng buộc giữa Công ty Cổ phần Digital and Stock
        và Thành viên khi sử dụng dịch vụ.</li>
      <li>Thành viên phải cung cấp thông tin đầy đủ, chính xác khi đăng ký tài khoản và chịu trách nhiệm bảo mật thông
        tin tài khoản của mình.</li>
      <li>Thành viên không được đăng ký tài khoản bằng thông tin giả mạo hoặc gây nhầm lẫn với cá nhân, tổ chức khác.
      </li>
      <li>Thông tin đăng tải trên Website 11N02 phải tuân thủ quy định pháp luật và không thuộc các trường hợp bị cấm.
      </li>
      <li>Thành viên không được thực hiện hành vi xâm phạm quyền, lợi ích hợp pháp, uy tín hoặc danh dự của tổ chức,
        cá nhân khác.</li>
      <li>Thành viên phải sử dụng ngôn ngữ rõ ràng, không sử dụng nội dung gây hiểu nhầm hoặc trái với thuần phong mỹ
        tục.</li>
      <li>Ban quản lý Sàn 11N02 có quyền kiểm tra, giám sát và xử lý các hành vi vi phạm; trong trường hợp cần thiết
        có thể tạm ngừng hoặc chấm dứt tài khoản vi phạm.</li>
    </ul>


    <!-- ===== III. QUY TRÌNH GIAO DỊCH ===== -->
    <h2>III. QUY TRÌNH GIAO DỊCH</h2>
    <p>Khách hàng muốn thực hiện giao dịch mua bán sản phẩm trên Website Sàn giao dịch thương mại điện tử 11N02 cần
      đăng ký tài khoản thành viên và sử dụng thiết bị điện tử có kết nối Internet (wifi hoặc mạng dữ liệu di động như
      3G/4G/5G), đồng thời thực hiện các quy trình giao dịch như sau:</p>

    <h3>1. Quy trình dành cho Khách hàng</h3>

    <h4>(1) Đăng ký</h4>
    <p>Để đăng ký tài khoản trên Website 11N02.com, Khách hàng truy cập vào trang chủ Website 11N02.com. Tại giao diện
      trang chủ, Khách hàng chọn mục "Tài khoản", sau đó chọn "Đăng ký".</p>
    <!-- IMAGE PLACEHOLDER: Vào trang chủ chọn Tài khoản, rồi Đăng ký -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture1.png" alt="Vào trang chủ chọn Tài khoản, rồi Đăng ký" />
      <p><em>Vào trang chủ chọn Tài khoản, rồi Đăng ký</em></p>
    </div>
    <p>Tại màn hình đăng ký, khách hàng nhập các thông tin theo biểu mẫu bao gồm email, số điện thoại, mật khẩu và xác
      nhận mật khẩu; đồng thời xác nhận đồng ý với quy chế hoạt động và chính sách của Website.</p>
    <!-- IMAGE PLACEHOLDER: Nhập thông tin Đăng ký -->
    <div class="policy__image-placeholder">
      <img src="assets/img/policy/Picture2.png" alt="Nhập thông tin Đăng ký" />
      <p><em>Nhập thông tin Đăng ký</em></p>
    </div>
    <p>Sau khi hoàn tất việc nhập thông tin, hệ thống gửi mã xác thực (OTP) đến địa chỉ email mà khách hàng đã đăng
      ký. Khách hàng nhập mã OTP để xác nhận tài khoản.</p>
    <!-- IMAGE PLACEHOLDER: Xác thực tài khoản qua email -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture3.png" alt="Xác thực tài khoản qua email" />
      <p><em>Xác thực tài khoản qua email</em></p>
    </div>
    <p>Trường hợp mã OTP hợp lệ, hệ thống thông báo xác thực thành công; tài khoản được tạo và khách hàng được đăng
      nhập vào hệ thống để sử dụng các chức năng trên Website.</p>
    <!-- IMAGE PLACEHOLDER: Xác thực xong là đăng ký thành công -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture4.png" alt="Xác thực xong là đăng ký thành công" />
      <p><em>Xác thực xong là đăng ký thành công</em></p>
    </div>

    <h4>(2) Đăng nhập</h4>
    <p>Để đăng nhập tài khoản trên Website 11N02.com, Khách hàng truy cập vào trang chủ Website 11N02.com. Tại giao
      diện trang chủ, Khách hàng chọn mục "Tài khoản", sau đó chọn "Đăng nhập".</p>
    <!-- IMAGE PLACEHOLDER: Vào trang chủ chọn Tài khoản, rồi Đăng nhập -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture5.png"alt="Vào trang chủ chọn Tài khoản, rồi Đăng nhập" />
      <p><em>Vào trang chủ chọn Tài khoản, rồi Đăng nhập</em></p>
    </div>
    <p>Khách hàng nhập thông tin tài khoản (email và mật khẩu) đã đăng ký và thực hiện đăng nhập.</p>
    <!-- IMAGE PLACEHOLDER: Nhập thông tin để đăng nhập -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture6.png" alt="Nhập thông tin để đăng nhập" />
      <p><em>Nhập thông tin để đăng nhập</em></p>
    </div>
    <p>Trường hợp thông tin hợp lệ, khách hàng đăng nhập thành công và được chuyển vào hệ thống để sử dụng các chức
      năng trên Website.</p>
    <!-- IMAGE PLACEHOLDER: Đăng nhập thành công -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture8.png" alt="Đăng nhập thành công" />
      <p><em>Đăng nhập thành công</em></p>
    </div>

    <h4>(3) Xem sản phẩm và thêm vào giỏ hàng</h4>
    <p>Để đặt mua sản phẩm trên Website 11N02.com, Khách hàng truy cập website, tìm kiếm hoặc lựa chọn sản phẩm phù
      hợp theo danh mục, bộ sưu tập hoặc kết quả tìm kiếm trên hệ thống.</p>
    <!-- IMAGE PLACEHOLDER: Chọn sản phẩm để xem chi tiết -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture9.png" alt="Chọn sản phẩm để xem chi tiết" />
      <p><em>Chọn sản phẩm để xem chi tiết</em></p>
    </div>
    <p>Tại trang chi tiết sản phẩm, Khách hàng xem thông tin sản phẩm, hình ảnh, giá bán, màu sắc, kích cỡ và các
      thông tin liên quan. Trường hợp sản phẩm có sẵn và không cần thiết kế thêm, Khách hàng lựa chọn thông số phù hợp
      như màu sắc, kích cỡ, số lượng và nhấn "Thêm vào giỏ hàng" để đưa sản phẩm vào giỏ hàng.</p>
    <!-- IMAGE PLACEHOLDER: Nhấn "Thêm vào giỏ hàng" -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture10.png" alt='Nhấn "Thêm vào giỏ hàng" để thêm sản phẩm vào giỏ hàng' />
      <p><em>Nhấn "Thêm vào giỏ hàng" để thêm sản phẩm vào giỏ hàng</em></p>
    </div>
    <!-- IMAGE PLACEHOLDER: Thêm vào giỏ hàng thành công -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture11.png" alt="Thêm vào giỏ hàng thành công" />
      <p><em>Thêm vào giỏ hàng thành công</em></p>
    </div>

    <h4>(4) Thiết kế sản phẩm theo yêu cầu</h4>
    <p>Đối với sản phẩm có hỗ trợ thiết kế cá nhân hóa, Khách hàng nhấn "Đến thiết kế" để chuyển sang giao diện thiết
      kế sản phẩm.</p>
    <!-- IMAGE PLACEHOLDER: Nhấn "Đến thiết kế" để thiết kế -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture13.png" alt='Nhấn "Đến thiết kế" để thiết kế' />
      <p><em>Nhấn "Đến thiết kế" để thiết kế</em></p>
    </div>
    <p>Tại trang thiết kế, Khách hàng thực hiện các thao tác tùy chỉnh theo nhu cầu như lựa chọn hình in/hình thêu,
      thêm chữ, thêm hình ảnh cá nhân, điều chỉnh vị trí hiển thị và xem trước mẫu thiết kế trên sản phẩm. Sau khi
      hoàn tất thiết kế, Khách hàng nhấn "Tiếp theo", lựa chọn kích cỡ phù hợp và thêm sản phẩm đã thiết kế vào giỏ
      hàng.</p>
    <!-- IMAGE PLACEHOLDER: Nhấn "Tiếp theo" -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture14.png" alt='Nhấn "Tiếp theo"' />
      <p><em>Nhấn "Tiếp theo"</em></p>
    </div>
    <!-- IMAGE PLACEHOLDER: Lựa chọn số lượng, kích thước để thêm vào giỏ hàng -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture15.png" alt="Lựa chọn số lượng, kích thước để thêm vào giỏ hàng" />
      <p><em>Lựa chọn số lượng, kích thước để thêm vào giỏ hàng</em></p>
    </div>

    <h4>(5) Xem giỏ hàng</h4>
    <p>Sau khi sản phẩm được thêm vào giỏ hàng, Khách hàng nhấn vào biểu tượng "Giỏ hàng" ở phần đầu website để xem
      giỏ hàng hiện tại. Tại trang giỏ hàng, hệ thống hiển thị danh sách sản phẩm đã chọn, thông tin sản phẩm, số
      lượng, đơn giá và tổng tiền tạm tính. Sau khi kiểm tra, Khách hàng nhấn "Thanh toán ngay" để chuyển sang bước đặt
      hàng và thanh toán.</p>
    <!-- IMAGE PLACEHOLDER: Xem chi tiết giỏ hàng -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture16.png" alt="Xem chi tiết giỏ hàng" />
      <p><em>Xem chi tiết giỏ hàng</em></p>
    </div>
    <h4>(6) Thanh toán</h4>
    <p>Tại trang thanh toán, Khách hàng nhập thông tin giao hàng, thông tin liên hệ, địa chỉ nhận hàng và thông tin bổ
      sung nếu có. Khách hàng lựa chọn phương thức thanh toán phù hợp và thực hiện thanh toán theo hướng dẫn. Sau khi
      thanh toán, hệ thống ghi nhận đơn hàng và chuyển thông tin đến Nhà cung cấp để xử lý.</p>
    <!-- IMAGE PLACEHOLDER: Lựa chọn phương thức thanh toán và tiến hành -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture17.png" alt="Lựa chọn phương thức thanh toán và tiến hành" />
      <p><em>Lựa chọn phương thức thanh toán và tiến hành</em></p>
    </div>
    <!-- IMAGE PLACEHOLDER: Thanh toán và đặt hàng thành công -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture18.png" alt="Thanh toán và đặt hàng thành công" />
      <p><em>Thanh toán và đặt hàng thành công</em></p>
    </div>

    <h4>(7) Quản lý lịch sử đơn hàng</h4>
    <p>Để theo dõi và quản lý các đơn hàng đã đặt, Khách hàng đăng nhập vào tài khoản trên Website 11N02.com, sau đó
      vào mục "Lịch sử đơn hàng" trong khu vực tài khoản.</p>
    <!-- IMAGE PLACEHOLDER: Trang lịch sử đơn hàng -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture19.png" alt="Trang lịch sử đơn hàng" />
      <p><em>Trang lịch sử đơn hàng</em></p>
    </div>

    <h4>(8) Hủy đơn hàng</h4>
    <p>Đối với đơn hàng còn ở trạng thái phù hợp để hủy, Khách hàng đăng nhập vào tài khoản, truy cập mục "Lịch sử
      đơn hàng", chọn đơn hàng cần hủy và nhấn chức năng "Hủy đơn hàng". Khách hàng nhập lý do hủy đơn theo biểu mẫu.
    </p>
    <!-- IMAGE PLACEHOLDER: Nhấn Hủy đơn hàng -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture20.png" alt="Nhấn Hủy đơn hàng" />
      <p><em>Nhấn Hủy đơn hàng</em></p>
    </div>
    <!-- IMAGE PLACEHOLDER: Đơn hàng Đã được hủy -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture21.png" alt="Đơn hàng Đã được hủy" />
      <p><em>Đơn hàng Đã được hủy</em></p>
    </div>
    <p>Sau khi yêu cầu hủy đơn hàng được xác nhận hợp lệ, 11N02 thực hiện hủy đơn trên hệ thống và liên hệ với Khách
      hàng để xác nhận thông tin hoàn tiền. Việc hoàn tiền được thực hiện bằng hình thức chuyển khoản vào tài khoản
      ngân hàng do Khách hàng cung cấp, trong thời gian tối đa 07 ngày làm việc.</p>

    <h4>(9) Quản lý thông tin tài khoản</h4>
    <p>Để xem và quản lý thông tin tài khoản, Khách hàng đăng nhập vào Website 11N02.com, sau đó vào mục "Tài khoản"
      và chọn "Thông tin".</p>
    <!-- IMAGE PLACEHOLDER: Tổng quan thông tin tài khoản -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture22.png" alt="Tổng quan thông tin tài khoản" />
      <p><em>Tổng quan thông tin tài khoản</em></p>
    </div>

    <h4>(10) Quản lý số đo cá nhân</h4>
    <p>Để nhập và cập nhật số đo cá nhân, Khách hàng đăng nhập vào Website 11N02.com, sau đó vào mục "Số đo của tôi"
      trong khu vực tài khoản.</p>
    <!-- IMAGE PLACEHOLDER: Trang số đo của tôi -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture23.png" alt="Trang số đo của tôi" />
      <p><em>Trang số đo của tôi</em></p>
    </div>

    <h4>(11) Quản lý danh sách yêu thích</h4>
    <p>Để xem lại danh sách sản phẩm yêu thích, Khách hàng đăng nhập vào tài khoản, sau đó vào mục "Danh sách yêu
      thích" trong khu vực tài khoản.</p>
    <!-- IMAGE PLACEHOLDER: Danh sách sản phẩm yêu thích -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture24.png" alt="Danh sách sản phẩm yêu thích" />
      <p><em>Danh sách sản phẩm yêu thích</em></p>
    </div>

    <h4>(12) Quản lý thiết kế của tôi</h4>
    <p>Sau khi hoàn tất thiết kế, Khách hàng có thể lưu mẫu thiết kế trên hệ thống. Để xem lại các thiết kế đã tạo,
      Khách hàng đăng nhập vào tài khoản, sau đó vào mục "Thiết kế của tôi" trong khu vực tài khoản.</p>
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture25.png" alt="Chọn Đăng ký nhà cung cấp" />
      <p><em>Quản lý thiết kế của tôi</em></p>
    </div>
    <h3>2. Quy trình dành cho Đối tác</h3>

    <h4>(1) Đăng ký</h4>
    <p>Để đăng ký tài khoản Nhà cung cấp trên Website 11N02, Nhà cung cấp truy cập Website, tại Trang chủ lựa chọn
      chức năng "Đăng ký nhà cung cấp".</p>

    <!-- IMAGE PLACEHOLDER: Nhập thông tin đăng ký -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture26.png" alt="Nhập thông tin đăng ký" />
      <p><em>Chọn Đăng ký nhà cung cấp</em></p>
    </div>

    <p>Tại màn hình đăng ký, Nhà cung cấp nhập đầy đủ thông tin theo biểu mẫu của hệ thống và xác nhận đồng ý với Quy
      chế hoạt động, chính sách liên quan của Website.</p>
    <!-- IMAGE PLACEHOLDER: Đăng ký thành công -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture27.png" alt="Đăng ký thành công" />
      <p><em>Nhập thông tin đăng ký</em></p>
    </div>
      <p>Sau khi gửi thông tin đăng ký, hệ thống ghi nhận thông tin và gửi email xác nhận đến địa chỉ email mà Nhà cung cấp đã đăng ký.</p>

    <!-- IMAGE PLACEHOLDER: Mở email để kích hoạt -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture28.png" alt="Mở email để kích hoạt" />
      <p><em>Đăng ký thành công</em></p>
    </div>
     <p>Nhà cung cấp truy cập email và thực hiện thao tác xác nhận/kích hoạt tài khoản theo hướng dẫn của hệ thống.</p>
    <!-- IMAGE PLACEHOLDER: Xác nhận email để kích hoạt tài khoản -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture29.png" alt="Xác nhận email để kích hoạt tài khoản" />
      <p><em>Mở email để kích hoạt</em></p>
    </div>
     <p>Sau khi xác nhận thành công, tài khoản Nhà cung cấp được kích hoạt để tiếp tục đăng nhập và sử dụng hệ thống.</p>

    <!-- IMAGE PLACEHOLDER: Đăng nhập nhà cung cấp -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture30.png" alt="Đăng nhập nhà cung cấp" />
      <p><em>Xác nhận email để kích hoạt tài khoản</em></p>
    </div>

     <h4>(2) Đăng nhập</h4>
    <p>Để đăng nhập tài khoản Nhà cung cấp, Nhà cung cấp truy cập Website, chọn mục "Tài khoản" và lựa chọn chức năng
      "Đăng nhập nhà cung cấp".</p>
    <!-- IMAGE PLACEHOLDER: Nhập thông tin để đăng nhập -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture31.png" alt="Nhập thông tin để đăng nhập" />
      <p><em>Đăng nhập nhà cung cấp</em></p>
    </div>

     <p>Tại màn hình đăng nhập, Nhà cung cấp nhập thông tin đăng nhập theo biểu mẫu của hệ thống.
      Trường hợp thông tin hợp lệ, hệ thống cho phép Nhà cung cấp truy cập vào khu vực quản lý dành cho Nhà cung cấp.</p>


    <!-- IMAGE PLACEHOLDER: Yêu cầu Cập nhật hồ sơ -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture32.png" alt="Yêu cầu Cập nhật hồ sơ" />
      <p><em>Nhập thông tin để đăng nhập</em></p>
    </div>

    <h4>(3) Cập nhật thông tin</h4>
    <p>Để cập nhật hồ sơ Nhà cung cấp, sau khi đăng nhập, Nhà cung cấp lựa chọn chức năng "Cập nhật hồ sơ" theo
      thông báo/hướng dẫn của hệ thống.</p>
    <!-- IMAGE PLACEHOLDER: Nhập thông tin để cập nhật hồ sơ -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture33.png" alt="Nhập thông tin để cập nhật hồ sơ" />
      <p><em>Yêu cầu Cập nhật hồ sơ</em></p>
    </div>

        <p>Tại màn hình cập nhật hồ sơ, Nhà cung cấp nhập đầy đủ các thông tin theo yêu cầu của hệ thống như thông tin cá nhân/tổ chức,
         thông tin liên hệ, địa chỉ và các thông tin liên quan khác.</p>
    <!-- IMAGE PLACEHOLDER: Cập nhật thành công -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture34.png" alt="Cập nhật thành công" />
      <p><em>Nhập thông tin để cập nhật hồ sơ</em></p>
    </div>
   <p>Sau khi hoàn tất, Nhà cung cấp lưu thông tin để hệ thống ghi nhận và cập nhật hồ sơ.</p>

       <!-- IMAGE PLACEHOLDER: Trang chủ quản lý -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture35.png" alt="Trang chủ quản lý" />
      <p><em>Cập nhật thành công</em></p>
    </div>
    <h4>(4) Ký hợp đồng</h4>
    <ul>
      <li>Sau khi Nhà cung cấp hoàn tất đăng ký và cập nhật hồ sơ, Ban quản trị website sẽ tiếp nhận thông tin và chủ
        động liên hệ để thực hiện ký kết hợp đồng hợp tác ngoài hệ thống.</li>
      <li>Sau khi hoàn tất ký kết hợp đồng, Nhà cung cấp được kích hoạt đầy đủ quyền và có thể chính thức triển khai
        hoạt động bán hàng trên sàn.</li>
      <li>Thời gian xử lý ký kết hợp đồng tối đa 07 ngày; trong trường hợp Nhà cung cấp không hoàn tất ký kết, Ban
        quản trị sẽ tạm ngừng hoặc dừng kích hoạt tài khoản cho đến khi hoàn tất hợp đồng.</li>
    </ul>

    <h4>(5) Trang chủ quản lý - Dashboard</h4>
    <p>Để theo dõi tổng quan hoạt động bán hàng, Nhà cung cấp đăng nhập vào khu vực quản lý và truy cập trang
      "Dashboard". Tại đây, hệ thống hiển thị các thông tin tổng quan như đơn hàng, doanh thu, trạng thái xử lý và các
      chỉ số liên quan.</p>
 <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture36.png" alt="Quản lý sản phẩm" />
      <p><em>Trang chủ quản lý</em></p>
    </div>

    <h4>(6) Quản lý sản phẩm</h4>
    <p>Để đăng tải hoặc quản lý sản phẩm, Nhà cung cấp truy cập mục “Quản lý sản phẩm” trong khu vực quản lý.
    Tại đây, Nhà cung cấp thực hiện thao tác thêm mới, chỉnh sửa hoặc quản lý danh sách sản phẩm đã đăng tải.
    Hệ thống hiển thị các thông tin liên quan đến sản phẩm như danh mục, giá, trạng thái duyệt và tình trạng hiển thị để Nhà cung cấp
    theo dõi và cập nhật khi cần thiết.</p>
    <!-- IMAGE PLACEHOLDER: Quản lý sản phẩm -->
    <!-- IMAGE PLACEHOLDER: Danh mục thư viện -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture37.png" alt="Danh mục thư viện" />
      <p><em>Quản lý sản phẩm</em></p>
    </div>

    <h4>(7) Quản lý danh mục thư viện</h4>
    <p> Để quản lý dữ liệu thư viện phục vụ việc đăng tải và thiết kế sản phẩm, Nhà cung cấp truy cập mục “Quản lý
    danh mục thư viện”. Tại đây, Nhà cung cấp thực hiện tạo mới, chỉnh sửa hoặc quản lý các danh mục dữ liệu như
    hình ảnh, mẫu thiết kế và các nội dung liên quan. Sau khi Nhà cung cấp lưu thông tin, hệ thống ghi nhận và cập
    nhật danh mục tương ứng.</p>
     <div class="policy__image-placeholder">
          <img src="/assets/img/policy/Picture38.png" alt="Loại sản phẩm" />
          <p><em>Danh mục thư viện</em></p>
        </div>

    <h4>(8) Tùy chỉnh sản phẩm</h4>
    <p>Để thiết lập các thông tin phục vụ việc tạo và cá nhân hóa sản phẩm, Nhà cung cấp truy cập mục “Tùy chỉnh sản phẩm”.
     Tại đây, Nhà cung cấp thiết lập các cấu hình liên quan đến sản phẩm như loại sản phẩm, nhóm sản phẩm, thuộc tính đi kèm
      và kích thước in. Các thông tin này được hệ thống ghi nhận để phục vụ quá trình đăng tải, quản lý và sản xuất sản phẩm
      theo nội dung đặt hàng của Khách hàng.</p>

    <!-- IMAGE PLACEHOLDER: Loại sản phẩm -->

    <!-- IMAGE PLACEHOLDER: Kích thước in -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture39.png" alt="Kích thước in" />
      <p><em>Loại sản phẩm</em></p>
    </div>

    <h4>(9) Quản lý đơn hàng</h4>
    <p>Để tiếp nhận và xử lý đơn hàng, Nhà cung cấp truy cập mục "Quản lý đơn hàng".</p>
    <!-- IMAGE PLACEHOLDER: Xem danh sách đơn hàng -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture40.png" alt="Xem danh sách đơn hàng" />
      <p><em>Kích thước in</em></p>
    </div>
    <!-- IMAGE PLACEHOLDER: Xem và xử lý đơn -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture41.png" alt="Xem và xử lý đơn" />
      <p><em>Xem danh sách đơn hàng</em></p>
    </div>
    <!-- IMAGE PLACEHOLDER: Quản lý mã giảm giá -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture42.png" alt="Xem và quản lý đơn" />
      <p><em>Xem và xử lý đơn</em></p>
    </div>
    <h4>(10) Quản lý mã giảm giá</h4>
    <p>Để tạo và quản lý chương trình khuyến mại, Nhà cung cấp truy cập mục "Quản lý đơn hàng", sau đó chọn mục "Mã
      giảm giá".</p>

    <!-- IMAGE PLACEHOLDER: Tạo mã giảm giá -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture43.png" alt="Tạo mã giảm giá" />
      <p><em>Quản lý mã giảm giá</em></p>
    </div>
        <p>Tại màn hình mã giảm giá, Nhà cung cấp nhập các thông tin theo biểu mẫu của hệ thống như mã giảm giá,
        tên chương trình, giá trị ưu đãi, điều kiện áp dụng, thời gian hiệu lực và phạm vi sử dụng. Sau khi lưu thông tin,
         hệ thống ghi nhận mã giảm giá để áp dụng theo đúng điều kiện Nhà cung cấp đã thiết lập.</p>
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture44.png" alt="Vào trang Lịch sử đơn hàng chọn Xem chi tiết đơn hàng muốn hủy" />
      <p><em>Tạo mã giảm giá</em></p>
    </div>
    <h4>(11) Tiếp nhận tư vấn</h4>
    <p>Để theo dõi các yêu cầu tư vấn từ Khách hàng, Nhà cung cấp truy cập mục “Tiếp nhận tư vấn”.
    Tại đây, hệ thống hiển thị danh sách yêu cầu tư vấn kèm các thông tin liên hệ như email, số điện thoại
     và nội dung quan tâm của Khách hàng. Nhà cung cấp căn cứ vào thông tin được ghi nhận để liên hệ, tư vấn và giải
     đáp thắc mắc cho Khách hàng. Việc tư vấn này chỉ nhằm hỗ trợ thông tin, không thay thế quy trình đặt hàng, thanh toán
     và giao dịch chính thức trên Sàn 11N02.</p>
    <!-- IMAGE PLACEHOLDER: Nhấn vào Hủy đơn hàng -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture45.png" alt="Nhấn vào Hủy đơn hàng" />
      <p><em>Quản lý tư vấn </em></p>
    </div>

    <h3>3. Quy trình giao nhận vận chuyển</h3>
    <p>Khi Người mua đặt mua hàng trên Sàn TMĐT 11N02, việc giao nhận đơn hàng được thực hiện thông qua đơn vị vận
      chuyển do Sàn kết nối và tích hợp trên hệ thống.</p>
    <p><strong>Phương thức:</strong> Sau khi Người mua hoàn tất đặt hàng, hệ thống 11N02 ghi nhận đơn hàng và chuyển
      thông tin đến Nhà bán hàng để xác nhận, chuẩn bị sản phẩm và đóng gói.</p>
    <p><strong>Thời gian:</strong> Thời gian giao hàng phụ thuộc vào thời điểm Nhà bán hàng xác nhận và chuẩn bị đơn
      hàng, địa chỉ nhận hàng, khu vực giao hàng và thời gian xử lý của đơn vị vận chuyển.</p>
    <p><strong>Giới hạn về mặt địa lý:</strong> Hoạt động giao nhận hàng hóa được thực hiện theo địa chỉ nhận hàng do
      Người mua cung cấp và phạm vi khu vực mà đơn vị vận chuyển liên kết với 11N02 hỗ trợ tại từng thời điểm.</p>
    <p><strong>Vai trò của Sàn 11N02:</strong> Sàn 11N02 đóng vai trò kết nối, ghi nhận và hỗ trợ theo dõi quá trình
      giao nhận. Sàn không trực tiếp thực hiện việc vận chuyển hàng hóa.</p>
    <p><strong>Quy trình giao nhận:</strong></p>
    <p><strong>Bước 1. Xác nhận đơn hàng:</strong> Sau khi Người mua hoàn tất đặt hàng, hệ thống 11N02 sẽ tự động ghi
      nhận đơn hàng và chuyển thông tin đến Nhà bán hàng để xác nhận và chuẩn bị sản phẩm.</p>
    <p><strong>Bước 2. Đóng gói và chuẩn bị giao hàng:</strong> Nhà bán hàng thực hiện đóng gói sản phẩm theo đơn
      hàng. Mã vận đơn đã được hệ thống tạo sẵn trong đơn hàng, Nhà bán hàng chỉ cần in thông tin vận đơn và dán lên
      kiện hàng.</p>
    <p><strong>Bước 3. Bàn giao cho đơn vị vận chuyển:</strong> Đơn vị vận chuyển do Sàn kết nối sẽ chủ động đến địa
      điểm của Nhà bán hàng để lấy hàng theo thông tin đơn đã tạo trên hệ thống.</p>
    <p><strong>Bước 4. Giao hàng đến Người mua:</strong> Đơn vị vận chuyển thực hiện giao hàng đến địa chỉ Người mua
      đã cung cấp.</p>
    <p><strong>Bước 5. Xử lý phát sinh (nếu có):</strong> Trong trường hợp phát sinh sự cố trong quá trình vận chuyển,
      Người mua có thể liên hệ với Nhà bán hàng hoặc gửi yêu cầu đến Sàn TMĐT 11N02 để được hỗ trợ.</p>

    <h3>4. Quy trình xác nhận/hủy đơn hàng</h3>

    <h4>a. Quy trình xác nhận đơn hàng</h4>
    <p>Sau khi sản phẩm được thêm vào giỏ hàng, Khách hàng nhấn vào biểu tượng "Giỏ hàng" ở phần đầu website để xem
      giỏ hàng hiện tại. Tại trang giỏ hàng, hệ thống hiển thị danh sách sản phẩm đã chọn,
       thông tin sản phẩm, số lượng, đơn giá và tổng tiền tạm tính. Khách hàng kiểm tra lại sản
       phẩm trong giỏ hàng, có thể cập nhật số lượng hoặc xóa sản phẩm nếu không còn nhu cầu. Sau
       khi kiểm tra thông tin giỏ hàng, Khách hàng nhấn “Thanh toán ngay” để chuyển sang bước đặt hàng
       và thanh toán.</p>
    <!-- IMAGE PLACEHOLDER: Nhập lý do hủy -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture46.png" alt="Xem chi tiết giỏ hàng" />
      <p><em>Xem chi tiết giỏ hàng</em></p>
    </div>
     <p>Tại trang thanh toán, Khách hàng nhập thông tin giao hàng, thông tin liên hệ,
         địa chỉ nhận hàng và thông tin bổ sung nếu có. Hệ thống hiển thị tóm tắt đơn hàng,
         bao gồm sản phẩm, số lượng, đơn giá, tiền hàng, phí vận chuyển, khuyến mại hoặc mã giảm giá nếu được
         áp dụng và tổng giá trị cần thanh toán.</p>
    <!-- IMAGE PLACEHOLDER: Đơn hàng đã được hủy thành công -->
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture47.png" alt="Đơn hàng đã được hủy thành công" />
      <p><em>Lựa chọn phương thức thanh toán và tiến hành</em></p>
    </div>

     <p>Khách hàng lựa chọn phương thức thanh toán phù hợp theo các phương thức được hệ thống hỗ trợ,
     kiểm tra lại toàn bộ thông tin đơn hàng và thực hiện thanh toán theo hướng dẫn, sau khi thanh toán,
      đơn hàng đã được đặt hàng thành công, hệ thống ghi nhận đơn hàng, cập nhật trạng thái đơn hàng trên
      Website và chuyển thông tin đơn hàng sang Nhà cung cấp/Người bán để tiếp nhận, kiểm tra và tiếp tục xử
      lý đơn hàng theo quy trình của Sàn.</p>
    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture48.png" alt="Thanh toán và đặt hàng thành công" />
      <p><em>Thanh toán và đặt hàng thành công</em></p>
    </div>
    <h4>b. Quy trình hủy đơn hàng</h4>
    <p>ĐĐối với đơn hàng còn ở trạng thái phù hợp để hủy, đặc biệt là khi Nhà bán hàng chưa xử lý
     hoặc chưa bàn giao đơn hàng cho đơn vị vận chuyển, Khách hàng có thể gửi yêu cầu hủy đơn hàng trên Website.</p>

    <p>Để hủy đơn hàng, Khách hàng đăng nhập vào tài khoản, truy cập mục “Lịch sử đơn hàng”,
    chọn đơn hàng cần hủy và nhấn chức năng “Hủy đơn hàng” nếu chức năng này còn được hệ thống hiển thị.
    Khách hàng nhập lý do hủy đơn theo biểu mẫu để hủy đơn</p>

    <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture49.png" alt="Thanh toán và đặt hàng thành công" />
      <p><em>Vào trang Lịch sử đơn hàng chọn Xem chi tiết đơn hàng muốn hủy</em></p>
    </div>
        <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture50.png" alt="Thanh toán và đặt hàng thành công" />
      <p><em>Nhấn vào Hủy đơn hàng</em></p>
    </div>
            <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture51.png" alt="Thanh toán và đặt hàng thành công" />
      <p><em>Nhập lý do hủy</em></p>
    </div>

      <div class="policy__image-placeholder">
      <img src="/assets/img/policy/Picture52.png" alt="Thanh toán và đặt hàng thành công" />
      <p><em>Đơn hàng đã được hủy thành công</em></p>
    </div>

   <p>Sau khi yêu cầu hủy đơn hàng được xác nhận hợp lệ, 11N02 thực hiện hủy đơn trên hệ thống và
   liên hệ với Khách hàng để xác nhận thông tin hoàn tiền. Việc hoàn tiền được thực hiện bằng hình
    thức chuyển khoản vào tài khoản ngân hàng do Khách hàng cung cấp, trong thời gian tối đa 07 ngày
    làm việc kể từ khi 11N02 nhận đủ thông tin tài khoản hoàn tiền hợp lệ. Phí chuyển khoản phát sinh,
     nếu có, do Khách hàng chịu theo biểu phí do ngân hàng công bố tại thời điểm thực hiện giao dịch.</p>




    <h3>5. Quy trình đổi trả hàng và hoàn tiền</h3>
    <p>Sàn TMĐT 11N02 ban hành chính sách đổi trả hàng và hoàn tiền áp dụng thống nhất đối với tất
cả các giao dịch phát sinh trên nền tảng. Người mua và người bán có trách nhiệm tuân thủ các điều
 kiện và quy trình do Sàn quy định nhằm đảm bảo tính minh bạch, công bằng và hạn chế các hành vi
 lợi dụng chính sách.</p>
    <p><strong>1. Điều kiện đổi trả hàng</strong></p>
    <ul>
      <li>Sản phẩm được yêu cầu đổi trả phải còn nguyên vẹn, chưa qua sử dụng, không bị hư hỏng do lỗi của người mua,
        còn đầy đủ bao bì, tem mác và phụ kiện kèm theo (nếu có).</li>
      <li>Thời gian yêu cầu đổi trả: trong vòng 05 (năm) ngày kể từ thời điểm người mua nhận hàng thành công.</li>
      <li>Các trường hợp được chấp nhận đổi trả bao gồm: sản phẩm không đúng với mô tả trên Sàn; sản phẩm bị lỗi, hư
        hỏng trong quá trình vận chuyển; giao sai sản phẩm, thiếu sản phẩm so với đơn hàng đã đặt.</li>
    </ul>

    <p><strong>2. Quy trình yêu cầu đổi trả và hoàn tiền</strong></p>
    <ul>
      <li>Bước 1: Người mua gửi yêu cầu đổi trả hoặc hoàn tiền thông qua hệ thống hỗ trợ của Sàn TMĐT 11N02 (hotline,
        email hoặc tài khoản người dùng), cung cấp đầy đủ thông tin gồm mã đơn hàng, lý do và hình ảnh chứng minh (nếu
        có).</li>
      <li>Bước 2: Sàn TMĐT 11N02 tiếp nhận và kiểm tra thông tin, xác minh điều kiện áp dụng.</li>
      <li>Bước 3: Sau khi nhận được sản phẩm hoàn trả (nếu có), Sàn phối hợp với người bán kiểm tra và đưa ra kết quả
        xử lý.</li>
      <li>Bước 4: Thực hiện đổi sản phẩm hoặc hoàn tiền cho người mua theo phương thức đã được xác nhận.</li>
    </ul>

    <p><strong>3. Chính sách hoàn tiền</strong></p>
    <ul>
      <li>Việc hoàn tiền được thực hiện theo phương thức chuyển khoản ngân hàng vào tài khoản của người mua cung cấp.
      </li>
      <li>Thời gian hoàn tiền dự kiến từ 07 – 10 ngày làm việc kể từ khi có kết quả xử lý.</li>
      <li>Trường hợp lỗi thuộc về người bán hoặc Sàn, toàn bộ chi phí liên quan đến hoàn tiền và vận chuyển sẽ do bên
        có lỗi chịu.</li>
    </ul>

    <p><strong>4. Các trường hợp không được áp dụng đổi trả hoặc hoàn tiền</strong></p>
    <ul>
      <li>Sản phẩm đã qua sử dụng, bị hư hỏng do lỗi của người mua.</li>
      <li>Sản phẩm không còn nguyên trạng ban đầu, thiếu tem mác, bao bì hoặc phụ kiện đi kèm.</li>
      <li>Quá thời hạn yêu cầu đổi trả theo quy định.</li>
      <li>Người mua không cung cấp đủ thông tin hoặc bằng chứng cần thiết để xác minh yêu cầu.</li>
      <li>Các trường hợp lợi dụng chính sách đổi trả nhằm trục lợi hoặc có dấu hiệu gian lận.</li>
    </ul>

    <h3>6. Quy trình bảo hành/bảo trì sản phẩm</h3>
    <p>Đối với các sản phẩm thời trang được giao dịch trên Sàn TMĐT 11N02, Sàn không áp dụng bảo hành. Người bán có
      trách nhiệm bảo đảm sản phẩm đúng thông tin đã công bố trên Sàn. Các vấn đề liên quan đến chất lượng sản phẩm sẽ
      được xử lý thông qua chính sách đổi trả và hoàn tiền do Sàn ban hành.</p>

    <h3>7. Quy trình giải quyết tranh chấp, khiếu nại</h3>
    <p>11N02 có trách nhiệm tiếp nhận khiếu nại và hỗ trợ người tiêu dùng trong quá trình sử dụng dịch vụ trên Sàn.
      Đầu mối tiếp nhận và giải quyết tranh chấp, khiếu nại là Bộ phận Chăm sóc khách hàng của 11N02 thông qua email
      <a href="mailto:11N02@gmail.com">11N02&#64;com</a> và số điện thoại 0901110102.</p>
    <p><strong>Bước 1: Tiếp nhận khiếu nại:</strong> Người dùng gửi khiếu nại qua Email: <a
        href="mailto:11N02@gmail.com">11N02&#64;com</a> hoặc Điện thoại: 0901110102.</p>
    <p><strong>Bước 2: Xác minh thông tin:</strong> 11N02 sẽ yêu cầu các bên liên quan cung cấp thông tin, tài liệu
      hoặc bằng chứng liên quan để phục vụ việc xác minh.</p>
    <p><strong>Bước 3: Phối hợp xử lý tranh chấp:</strong> Tùy theo tính chất của khiếu nại, 11N02 sẽ phối hợp với
      các bên liên quan để xử lý phù hợp.</p>
    <p><strong>Bước 4: Thông báo kết quả xử lý:</strong> Sau khi xác minh và xử lý, 11N02 sẽ thông báo kết quả giải
      quyết khiếu nại cho các bên liên quan. Thời gian xử lý khiếu nại thông thường không quá 03 đến 05 ngày làm việc.
    </p>
    <p><strong>Bước 5: Chế tài xử lý vi phạm:</strong> Trong trường hợp xác minh được lỗi phát sinh từ phía Người bán,
      đơn vị vận chuyển hoặc thành viên tham gia hệ thống, Ban quản lý Sàn có thể áp dụng các biện pháp xử lý phù hợp
      bao gồm cảnh cáo, yêu cầu thực hiện đúng cam kết, yêu cầu phối hợp đổi trả/hoàn tiền, tạm ẩn sản phẩm, tạm
      ngừng quyền bán hàng hoặc khóa tài khoản.</p>


    <!-- ===== IV. QUY TRÌNH THANH TOÁN ===== -->
    <h2>IV. QUY TRÌNH THANH TOÁN</h2>

    <h3>1. Thanh toán giữa người mua và người bán</h3>
    <p>Để mang lại sự tiện lợi và linh hoạt cho người mua khi giao dịch trên sàn, 11N02 hiện hỗ trợ hai phương thức
      thanh toán:</p>
    <ul>
      <li><strong>Thanh toán trực tuyến qua cổng VNPay:</strong> Hệ thống sẽ chuyển hướng đến trang thanh toán của
        VNPay để người mua thực hiện thanh toán 100% giá trị đơn hàng.</li>
      <li><strong>Thanh toán khi nhận hàng (COD):</strong> Người mua sẽ thanh toán trực tiếp cho đơn vị vận chuyển khi
        nhận hàng.</li>
    </ul>
    <p>Tất cả giao dịch thanh toán đều được chuyển về tài khoản ngân hàng sau:</p>
    <ul>
      <li>Số tài khoản: <strong>3005258888</strong></li>
      <li>Tên tài khoản: <strong>Công ty cổ phần DIGITAL AND STOCK</strong></li>
      <li>Ngân hàng mở tài khoản: <strong>MB Bank</strong></li>
    </ul>

    <h3>2. Thanh toán giữa đối tác và sàn 11N02</h3>
    <ul>
      <li><strong>Phí sàn:</strong> 15% trên tổng doanh thu thực tế của nhà bán hàng nhận được (theo hợp đồng thỏa
        thuận tại từng thời điểm).</li>
      <li><strong>Đối soát công nợ:</strong> Thực hiện 3 lần mỗi tháng: lần 1 (ngày 1–10), lần 2 (ngày 11–20), lần 3
        (ngày 21 đến hết tháng).</li>
      <li><strong>Thanh toán công nợ:</strong> Sau khi hoàn tất đối soát và đảm bảo đơn hàng không phát sinh khiếu nại
        trong thời hạn 14 ngày, Sàn 11N02 sẽ khấu trừ các khoản phí và chuyển khoản phần còn lại cho Nhà cung cấp.
      </li>
    </ul>


    <!-- ===== V. ĐẢM BẢO AN TOÀN GIAO DỊCH ===== -->
    <h2>V. ĐẢM BẢO AN TOÀN GIAO DỊCH</h2>
    <p>Để đảm bảo an toàn giao dịch trên Website Sàn giao dịch thương mại điện tử 11N02, Ban quản lý Sàn áp dụng các
      biện pháp sau:</p>
    <ul>
      <li>Cung cấp đầy đủ thông tin liên quan đến sản phẩm, giá bán, phí vận chuyển, phương thức thanh toán, điều kiện
        giao dịch, chính sách kiểm hàng, đổi trả và hoàn tiền để Khách hàng tham khảo trước khi thực hiện giao dịch.
      </li>
      <li>Áp dụng các giải pháp kỹ thuật nhằm bảo vệ thông tin tài khoản, thông tin đơn hàng, dữ liệu giao dịch và
        thông tin thanh toán của Khách hàng.</li>
      <li>Dữ liệu thanh toán được mã hóa trong quá trình truyền tải nhằm hạn chế nguy cơ truy cập trái phép.</li>
      <li>Có cơ chế tiếp nhận và xử lý các phản ánh, khiếu nại liên quan đến tài khoản, đơn hàng, thanh toán, giao
        nhận, đổi trả và các vấn đề kỹ thuật phát sinh.</li>
      <li>Thường xuyên kiểm tra, rà soát, cập nhật và nâng cấp hệ thống kỹ thuật nhằm bảo đảm an toàn, bảo mật dữ
        liệu.</li>
    </ul>


    <!-- ===== VI. CHÍNH SÁCH BẢO VỆ THÔNG TIN CÁ NHÂN ===== -->
    <h2>VI. CHÍNH SÁCH BẢO VỆ THÔNG TIN CÁ NHÂN CỦA NGƯỜI TIÊU DÙNG</h2>

    <h4>i) Mục đích thu thập thông tin cá nhân</h4>
    <p>Sàn 11N02 thu thập thông tin cá nhân của người tiêu dùng cho các mục đích: đăng ký tài khoản và sử dụng dịch
      vụ; xác thực, quản lý tài khoản thành viên và hỗ trợ người dùng; cung cấp dịch vụ theo yêu cầu; thực hiện các
      nghĩa vụ theo quy định của pháp luật.</p>
    <p>Thông tin thu thập bao gồm: họ và tên, email, số điện thoại (bắt buộc khi đăng ký); thông tin địa chỉ nhận hàng;
      số đo cá nhân, danh sách yêu thích, thiết kế đã tạo (do người dùng tự cung cấp).</p>

    <h4>ii) Phạm vi sử dụng thông tin cá nhân</h4>
    <p>11N02 sử dụng thông tin cá nhân trong phạm vi cần thiết để: cung cấp dịch vụ; xử lý đơn hàng, thanh toán, giao
      nhận, đổi trả, hoàn tiền; liên hệ, phản hồi các yêu cầu của người dùng; thực hiện các nghĩa vụ theo quy định của
      pháp luật.</p>
    <p>11N02 cam kết không bán, không chia sẻ và không tiết lộ thông tin cá nhân của người tiêu dùng cho bên thứ ba
      nếu không có sự đồng ý của người tiêu dùng, trừ trường hợp pháp luật có quy định khác.</p>

    <h4>iii) Thời gian lưu trữ thông tin cá nhân</h4>
    <p>Sàn 11N02 sẽ lưu trữ thông tin cá nhân của người tiêu dùng trong thời gian cần thiết để cung cấp dịch vụ và
      thực hiện các nghĩa vụ theo quy định của pháp luật. Sau khi không còn cần thiết, 11N02 sẽ xóa hoặc làm ẩn thông
      tin cá nhân của khách hàng.</p>

    <h4>iv) Những người hoặc tổ chức có thể được tiếp cận với thông tin</h4>
    <p>Thông tin cá nhân của người tiêu dùng có thể được tiếp cận bởi: Công ty Cổ phần Digital and Stock; các bộ phận
      nội bộ có liên quan của 11N02; Người bán/Nhà cung cấp (trong phạm vi xử lý đơn hàng); đơn vị vận chuyển; cơ quan
      nhà nước có thẩm quyền khi có yêu cầu theo quy định của pháp luật.</p>

    <h4>v) Địa chỉ của đơn vị thu thập và quản lý thông tin</h4>
    <ul>
      <li>Tên tổ chức: Công ty cổ phần DIGITAL AND STOCK</li>
      <li>Địa chỉ: 185A-185B Đường Hà Huy Giáp, Phường Thạnh Lộc, Quận 12, Thành phố Hồ Chí Minh, Việt Nam</li>
      <li>Email: <a href="mailto:11N02@gmail.com">11N02&#64;com</a></li>
      <li>Điện thoại: 0901110102</li>
    </ul>

    <h4>vi) Phương thức và công cụ để người tiêu dùng tiếp cận và chỉnh sửa dữ liệu cá nhân</h4>
    <p>Người dùng đăng nhập Sàn 11N02 và có thể chỉnh sửa dữ liệu cá nhân của mình tại Trang Hồ sơ tài khoản, trong
      mục <strong>Cài đặt</strong>. Trường hợp cần hỗ trợ, người dùng có thể liên hệ với 11N02 qua số điện thoại hoặc
      email được công bố trên Website.</p>

    <h4>vii) Cam kết bảo mật thông tin cá nhân khách hàng</h4>
    <p>11N02 cam kết đảm bảo an toàn, an ninh cho thông tin cá nhân đã thu thập và lưu trữ từ khách hàng, đồng thời cam
      kết ngăn ngừa các hành vi đánh cắp hoặc tiếp cận thông tin trái phép; sử dụng thông tin trái phép; thay đổi, phá
      hủy thông tin trái phép.</p>

    <h4>viii) Cơ chế tiếp nhận và giải quyết khiếu nại liên quan đến thông tin cá nhân khách hàng</h4>
    <p><strong>Bước 1:</strong> Người dùng gửi khiếu nại qua email <a
        href="mailto:11N02@gmail.com">11N02&#64;com</a> hoặc gọi điện thoại vào số hotline 0901110102.</p>
    <p><strong>Bước 2:</strong> Sau khi tiếp nhận khiếu nại, 11N02 tiến hành kiểm tra, xác minh thông tin. Thời gian xử
      lý tối đa là 05 ngày làm việc kể từ ngày tiếp nhận đầy đủ thông tin cần thiết.</p>
    <p><strong>Bước 3:</strong> Kết quả xử lý khiếu nại được thông báo cho người dùng qua số điện thoại hoặc địa chỉ
      email đã đăng ký.</p>


    <!-- ===== VII. QUẢN LÝ THÔNG TIN TRÊN NỀN TẢNG ===== -->
    <h2>VII. QUẢN LÝ THÔNG TIN TRÊN NỀN TẢNG</h2>

    <h4>i) Kiểm soát thông tin Người bán</h4>
    <p><strong>Thông tin Người bán cần cung cấp trên 11N02 gồm:</strong> thông tin tài khoản, thông tin cá nhân/tổ
      chức, thông tin của Shop, thông tin phục vụ thanh toán và đối soát.</p>
    <p><strong>11N02 sử dụng các phương pháp kiểm soát thông tin người bán gồm:</strong> kiểm tra tự động (xác thực
      trường bắt buộc); kiểm tra thủ công (đối chiếu thông tin với tài liệu thực tế); kiểm tra chéo (đối chiếu với
      nguồn thông tin khác).</p>
    <p><strong>Tần suất kiểm soát:</strong> định kỳ (rà soát theo chu kỳ trong quá trình vận hành) và đột xuất (khi có
      dấu hiệu vi phạm hoặc phát sinh phản ánh, khiếu nại).</p>

    <h4>ii) Kiểm soát thông tin sản phẩm</h4>
    <p><strong>Người bán khi đăng tin sản phẩm phải tuân thủ:</strong> cung cấp thông tin đầy đủ, rõ ràng và chính xác
      (tên sản phẩm, mô tả, giá cả, nguồn gốc, xuất xứ,...); sử dụng ngôn ngữ văn minh, lịch sự; hình ảnh phải đúng
      mô tả; tin đăng phải đúng phân loại và danh mục; không chứa từ khóa bị cấm.</p>
    <p><strong>Các sản phẩm bị cấm đăng tải:</strong> sản phẩm có nội dung phản động, khiêu dâm, bạo lực; tài liệu bí
      mật; thông tin vi phạm pháp luật; thông tin sai sự thật; nội dung xúc phạm tổ chức, cá nhân; vi phạm quyền sở
      hữu trí tuệ.</p>
    <p><strong>Phương pháp kiểm soát:</strong> kiểm tra thủ công (nhân viên 11N02 kiểm tra nội dung hàng ngày) và kiểm
      tra tự động (hệ thống cảnh báo từ khóa bị cấm).</p>

    <h4>iii) Quy trình phối hợp với chủ thể quyền sở hữu trí tuệ</h4>
    <p><strong>Bước 1:</strong> Chủ thể quyền gửi thông báo đến sàn 11N02 kèm tài liệu, bằng chứng chứng minh quyền sở
      hữu trí tuệ.</p>
    <p><strong>Bước 2:</strong> Sàn 11N02 tiếp nhận và kiểm tra các thông tin, tài liệu được cung cấp.</p>
    <p><strong>Bước 3:</strong> Sàn 11N02 thông báo cho thành viên đăng tải nội dung bị khiếu nại.</p>
    <p><strong>Bước 4:</strong> Sàn 11N02 thực hiện ẩn nội dung, gỡ bỏ thông tin vi phạm hoặc xử lý tài khoản vi phạm
      nếu được xác nhận.</p>
    <p><strong>Bước 5:</strong> Sàn 11N02 thông báo kết quả xử lý cho các bên liên quan.</p>
    <p><strong>Bước 6:</strong> Trong trường hợp phức tạp, sàn 11N02 hướng dẫn các bên giải quyết tại cơ quan nhà nước
      có thẩm quyền.</p>

    <h4>iv) Chế tài và biện pháp xử lý vi phạm</h4>
    <ul>
      <li>Đối với hành vi vi phạm quy định về thông tin: gửi cảnh báo qua email, yêu cầu điều chỉnh trong 03 ngày làm
        việc, tạm ẩn tin đăng vi phạm.</li>
      <li>Đối với thông tin thuộc danh mục cấm hoặc vi phạm pháp luật: gửi cảnh báo và xóa tin vi phạm.</li>
      <li>Tài khoản vi phạm từ lần thứ 04 trở đi sẽ bị xóa tài khoản và thông báo qua email.</li>
      <li>Thành viên sẽ chịu hoàn toàn trách nhiệm trước pháp luật nếu cố tình đăng tải các nội dung bị cấm.</li>
    </ul>


    <!-- ===== VIII. TRÁCH NHIỆM KHI PHÁT SINH LỖI KỸ THUẬT ===== -->
    <h2>VIII. TRÁCH NHIỆM TRONG TRƯỜNG HỢP PHÁT SINH LỖI KỸ THUẬT</h2>
    <ul>
      <li>11N02 cam kết nỗ lực đảm bảo sự an toàn và ổn định của toàn bộ hệ thống kỹ thuật. Trong trường hợp xảy ra
        sự cố do lỗi của 11N02 sẽ ngay lập tức áp dụng các biện pháp để đảm bảo quyền lợi cho người sử dụng.</li>
      <li>Khi thực hiện các giao dịch trên 11N02 bắt buộc các thành viên phải thực hiện đúng theo các quy trình hướng
        dẫn.</li>
      <li>Trường hợp phát sinh lỗi kỹ thuật, lỗi phần mềm hoặc các lỗi khách quan khác, các Thành viên thông báo cho
        Ban quản lý sàn qua email hoặc hotline để có những biện pháp xử lý kịp thời.</li>
      <li>Ban quản trị sàn 11N02 sẽ không chịu trách nhiệm giải quyết trong trường hợp thông báo của các thành viên
        không đến được ban quản trị do lỗi đường truyền, phần mềm hoặc các lỗi khác không do ban quản trị gây ra.</li>
    </ul>


    <!-- ===== IX. QUYỀN VÀ TRÁCH NHIỆM CỦA BQL SÀN TMĐT 11N02 ===== -->
    <h2>IX. QUYỀN VÀ TRÁCH NHIỆM CỦA BQL SÀN TMĐT 11N02</h2>

    <h3>a. Quyền của Ban quản lý sàn 11N02</h3>
    <ul>
      <li>Tiến hành cung cấp các dịch vụ trên nền tảng cho những thành viên tham gia sau khi hoàn thành thủ tục đăng ký
        tài khoản và đáp ứng các điều kiện sử dụng dịch vụ.</li>
      <li>Toàn quyền thay đổi, chỉnh sửa, bổ sung hoặc loại bỏ các Quy định sử dụng dịch vụ bằng cách cập nhật trên
        website 11N02 vào bất kỳ thời điểm nào và sẽ thông báo tối thiểu 05 ngày trước khi áp dụng.</li>
      <li>Quyền từ chối, tạm ngừng hoặc chấm dứt cung cấp dịch vụ cho thành viên trong trường hợp vi phạm.</li>
      <li>Quyền tạm ẩn hiển thị hoặc gỡ bỏ các thông tin, sản phẩm, nội dung vi phạm chính sách hoặc quy định pháp
        luật.</li>
      <li>Giữ bản quyền đối với toàn bộ hệ thống phần mềm, giao diện, cơ sở dữ liệu và các nội dung hiển thị trên
        website 11N02.</li>
      <li>Quyền điều chỉnh bảng giá dịch vụ, chính sách phí, mức chiết khấu và phương thức thanh toán.</li>
      <li>Quyền xây dựng và triển khai các chương trình ưu đãi, khuyến mại hoặc hỗ trợ dịch vụ.</li>
      <li>Quyền giám sát hoạt động của các thành viên và xử lý các hành vi vi phạm theo Quy chế hoạt động.</li>
    </ul>

    <h3>b. Trách nhiệm của Ban quản lý sàn 11N02</h3>
    <ul>
      <li>Đăng ký thiết lập website cung cấp dịch vụ sàn giao dịch thương mại điện tử theo quy định tại Nghị định
        52/2013/NĐ-CP đã được sửa đổi, bổ sung theo Nghị định 85/2021/NĐ-CP.</li>
      <li>Xây dựng và công bố công khai Quy chế hoạt động của Sàn 11N02.</li>
      <li>Yêu cầu các thành viên cung cấp đầy đủ các thông tin cần thiết khi đăng ký tài khoản.</li>
      <li>Thẩm tra và xác thực các thông tin đăng ký của thành viên.</li>
      <li>Lưu trữ thông tin đăng ký của các thành viên và thường xuyên cập nhật theo quy định.</li>
      <li>Áp dụng các biện pháp cần thiết nhằm đảm bảo an toàn thông tin cá nhân của thành viên.</li>
      <li>Xử lý kịp thời các hành vi vi phạm pháp luật hoặc vi phạm Quy chế hoạt động.</li>
      <li>Hỗ trợ cơ quan quản lý nhà nước điều tra các hành vi vi phạm pháp luật trên Sàn khi có yêu cầu.</li>
      <li>Tiếp nhận và giải quyết các khiếu nại, phản ánh và tranh chấp liên quan đến việc sử dụng dịch vụ trên Sàn.
      </li>
      <li>Thực hiện đầy đủ nghĩa vụ thuế theo quy định của pháp luật.</li>
    </ul>


    <!-- ===== X. QUYỀN VÀ TRÁCH NHIỆM CỦA CÁC BÊN THAM GIA ===== -->
    <h2>X. QUYỀN VÀ TRÁCH NHIỆM CỦA CÁC BÊN THAM GIA WEBSITE CUNG CẤP DỊCH VỤ THƯƠNG MẠI ĐIỆN TỬ 11N02</h2>

    <h3>1. Quyền và trách nhiệm của Thành viên (Người bán) trên sàn 11N02</h3>

    <h4>a. Quyền của Thành viên (Người bán)</h4>
    <ul>
      <li>Quyền đăng ký tham gia hệ thống 11N02 và sử dụng các dịch vụ/tiện ích được cung cấp trên website.</li>
      <li>Được cấp tài khoản đăng nhập để quản lý thông tin gian hàng, sản phẩm, đơn hàng, mã giảm giá.</li>
      <li>Được sử dụng các công cụ quản lý bán hàng, thanh toán trực tuyến, quảng bá sản phẩm/dịch vụ.</li>
      <li>Quyền đăng tải, chỉnh sửa, quản lý sản phẩm, thông tin gian hàng theo đúng quy định của Sàn.</li>
      <li>Quyền tiếp nhận, kiểm tra và xử lý các đơn hàng phát sinh từ Người mua.</li>
      <li>Quyền triển khai chương trình khuyến mại, mã giảm giá theo chính sách của Sàn.</li>
      <li>Được nhận phần doanh thu còn lại sau khi Sàn thực hiện đối soát, khấu trừ các khoản phí.</li>
      <li>Quyền yêu cầu Sàn 11N02 hỗ trợ trong quá trình vận hành gian hàng.</li>
      <li>Quyền đóng góp ý kiến, phản ánh, khiếu nại qua email <a
          href="mailto:11N02@gmail.com">11N02&#64;com</a> hoặc số hotline 0901110102.</li>
    </ul>

    <h4>b. Trách nhiệm của Thành viên (Người bán)</h4>
    <ul>
      <li>Cung cấp đầy đủ, chính xác thông tin khi đăng ký tài khoản, cập nhật hồ sơ và ký kết hợp đồng.</li>
      <li>Bảo mật tên đăng nhập, mật khẩu và các thông tin liên quan đến tài khoản.</li>
      <li>Cung cấp đầy đủ, chính xác, trung thực thông tin về sản phẩm/dịch vụ khi đăng tải lên Sàn.</li>
      <li>Chịu trách nhiệm trước pháp luật và trước Người mua về tính chính xác, hợp pháp, chất lượng, nguồn gốc sản
        phẩm.</li>
      <li>Tiếp nhận, kiểm tra và xử lý đơn hàng; thực hiện đóng gói và bàn giao hàng hóa cho đơn vị vận chuyển.</li>
      <li>Phối hợp với 11N02, Người mua và đơn vị vận chuyển trong việc xử lý các vấn đề phát sinh.</li>
      <li>Tuân thủ quy định của pháp luật về thanh toán, quảng cáo, khuyến mại, bảo vệ quyền sở hữu trí tuệ.</li>
      <li>Không sử dụng dịch vụ của 11N02 vào các mục đích bất hợp pháp.</li>
    </ul>

    <h3>2. Quyền và trách nhiệm của Khách hàng (Người sử dụng dịch vụ) trên sàn 11N02</h3>

    <h4>a. Quyền của Khách hàng trên sàn 11N02</h4>
    <ul>
      <li>Quyền đăng ký tài khoản, truy cập, tìm kiếm, lựa chọn sản phẩm và sử dụng các chức năng trên Website.</li>
      <li>Được cung cấp thông tin chính xác, đầy đủ về sản phẩm, giá bán, phí vận chuyển, phương thức thanh toán,
        chính sách đổi trả.</li>
      <li>Quyền đặt mua sản phẩm, theo dõi trạng thái đơn hàng, yêu cầu hủy đơn trong trường hợp đủ điều kiện.</li>
      <li>Quyền phản ánh hoặc khiếu nại trong trường hợp sản phẩm không đúng mô tả hoặc phát sinh vấn đề giao nhận.
      </li>
      <li>Được bảo mật thông tin cá nhân theo quy định của pháp luật và chính sách bảo mật của 11N02.</li>
    </ul>

    <h4>b. Trách nhiệm của Khách hàng trên sàn 11N02</h4>
    <ul>
      <li>Cung cấp thông tin chính xác, đầy đủ khi đăng ký tài khoản, đặt hàng, thanh toán, cập nhật thông tin nhận
        hàng.</li>
      <li>Bảo mật tên đăng nhập, mật khẩu và các thông tin liên quan đến tài khoản.</li>
      <li>Kiểm tra kỹ thông tin sản phẩm, số lượng, kích cỡ, địa chỉ nhận hàng và tổng giá trị đơn hàng trước khi xác
        nhận đặt hàng.</li>
      <li>Thanh toán đầy đủ giá trị đơn hàng, phí vận chuyển và các chi phí phát sinh hợp lệ khác.</li>
      <li>Không sử dụng Website vào mục đích vi phạm pháp luật, gian lận, phá hoại hệ thống hoặc tạo đơn hàng giả.
      </li>
      <li>Chịu trách nhiệm về mọi hành vi của mình khi sử dụng Website và các dịch vụ trên Website.</li>
    </ul>


    <!-- ===== XI. ĐIỀU KHOẢN ÁP DỤNG ===== -->
    <h2>XI. ĐIỀU KHOẢN ÁP DỤNG</h2>
    <p>Quy chế hoạt động của Sàn giao dịch thương mại điện tử 11N02 chính thức có hiệu lực thi hành kể từ ngày ký
      Quyết định ban hành kèm theo Quy chế này.</p>
    <p>11N02 có quyền sửa đổi, bổ sung các nội dung của Quy chế này. Khi đó, Ban quản lý 11N02 sẽ thông báo công khai
      nội dung thay đổi trên website. Quy chế sửa đổi sẽ có hiệu lực sau 05 (năm) ngày kể từ khi thông báo được đăng
      tải.</p>
    <p>Các Thành viên tham gia giao dịch trên sàn 11N02 có trách nhiệm tuân thủ các nội dung của Quy chế hiện hành.</p>


    <!-- ===== XII. ĐIỀU KHOẢN CAM KẾT ===== -->
    <h2>XII. ĐIỀU KHOẢN CAM KẾT</h2>
    <p>Thành viên khi tham gia hoạt động trên Sàn giao dịch thương mại điện tử 11N02 đồng nghĩa với việc các bên có
      liên quan đã đọc, hiểu và chấp thuận tuân thủ các quy định của Quy chế này.</p>
    <p>Mọi thắc mắc của Khách hàng vui lòng liên hệ với 11N02 theo thông tin dưới đây để được giải đáp:</p>
    <ul>
      <li>Website: <a href="https://11n02.com/" target="_blank">https://11n02.com/</a></li>
      <li>Tên công ty: Công ty cổ phần DIGITAL AND STOCK</li>
      <li>Địa chỉ: 185A-185B Đường Hà Huy Giáp, Phường Thạnh Lộc, Quận 12, Thành phố Hồ Chí Minh, Việt Nam</li>
      <li>Email: <a href="mailto:11N02@gmail.com">11N02&#64;com</a></li>
      <li>Hotline: 0901110102</li>
    </ul>

  </div>
</div>